import {inject, Pipe, PipeTransform} from '@angular/core';
import {DateTime} from 'luxon';
import {formatTime, TranslateService} from '@brunata-angular/util';

@Pipe({
    name: 'apptime',
    standalone: true,
})
export class TimePipe implements PipeTransform {
    private translateService = inject(TranslateService);

    transform(value: DateTime | null | undefined): string {
        if (value == null || !value.isValid) {
            return '';
        }
        return formatTime(value, this.translateService.language);
    }
}
